/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How reset timing is calculated
 * @export
 */
export const ResetTimingMode = {
    RELATIVE: 'RELATIVE',
    CALENDAR_ALIGNED: 'CALENDAR_ALIGNED'
} as const;
export type ResetTimingMode = typeof ResetTimingMode[keyof typeof ResetTimingMode];


export function instanceOfResetTimingMode(value: any): boolean {
    for (const key in ResetTimingMode) {
        if (Object.prototype.hasOwnProperty.call(ResetTimingMode, key)) {
            if (ResetTimingMode[key as keyof typeof ResetTimingMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResetTimingModeFromJSON(json: any): ResetTimingMode {
    return ResetTimingModeFromJSONTyped(json, false);
}

export function ResetTimingModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetTimingMode {
    return json as ResetTimingMode;
}

export function ResetTimingModeToJSON(value?: ResetTimingMode | null): any {
    return value as any;
}

export function ResetTimingModeToJSONTyped(value: any, ignoreDiscriminator: boolean): ResetTimingMode {
    return value as ResetTimingMode;
}

